import React from "react";
import { Typography, Paper, Box } from "@mui/material";

function ContactUs() {
  return (
    <Box
      sx={{
        backgroundColor: "#f4f9ff",
        minHeight: "100vh",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <div className="header">
        <img src="/logo.png" alt="Logo" className="logo" />
        <div className="heading-text">
          <br />
          <h1 className="title">Smart Parking App</h1>
          <p className="caption">"Empowering Digital India .."</p>
        </div>
      </div>
      <h1 className="title">Contact Us</h1>

      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 4,
          backgroundColor: "#ffffff",
          maxWidth: 600,
          width: "90%",
          mx: "auto",
          textAlign: "center",
        }}
      >
        <Typography variant="body1" gutterBottom>
          Reach out to us for any queries or assistance regarding parking in the Kalimpong Municipality area.
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" sx={{ color: "#1976d2", mb: 2 }}>
            <span
              style={{
                display: "inline-block",
                animation: "bounce 1.5s infinite",
              }}
            >
              Email
            </span>
          </Typography>
          <Typography variant="body1">
            <a
              href="mailto:parkingsupport@apptech.co.in"
              style={{
                color: "#1976d2",
                textDecoration: "none",
                animation: "pulse 2s infinite",
              }}
            >
              parkingsupport@apptech.co.in
            </a>
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" sx={{ color: "#1976d2", mb: 2 }}>
            <span
              style={{
                display: "inline-block",
                animation: "bounce 1.5s infinite",
              }}
            >
              Phone
            </span>
          </Typography>
          <Typography variant="body1">
            <a
              href="tel:+917001841402"
              style={{
                color: "#1976d2",
                textDecoration: "none",
                animation: "pulse 2s infinite",
              }}
            >
              +91 7001841402
            </a>
          </Typography>
        </Box>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" sx={{ color: "#1976d2", mb: 2 }}>
            <span
              style={{
                display: "inline-block",
                animation: "bounce 1.5s infinite",
              }}
            >
              Address
            </span>
          </Typography>
          <Typography variant="body1">
            <span
              style={{
                display: "inline-block",
                animation: "fadeIn 2s infinite",
              }}
            >
              Smart Parking Office,
              <br />
              Main Road, Kalimpong,
              <br />
              West Bengal, India - 734301
            </span>
          </Typography>
        </Box>

        {/* Inline CSS for animations */}
        <style>
          {`
            @keyframes bounce {
              0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
              40% { transform: translateY(-10px); }
              60% { transform: translateY(-5px); }
            }
            @keyframes pulse {
              0% { transform: scale(1); }
              50% { transform: scale(1.05); }
              100% { transform: scale(1); }
            }
            @keyframes fadeIn {
              0% { opacity: 0.6; }
              50% { opacity: 1; }
              100% { opacity: 0.6; }
            }
          `}
        </style>
      </Paper>
    </Box>
  );
}

export default ContactUs;